import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center px-4">
      <p className="text-muted t-eyebrow">Navigation</p>
      <h1 className="t-display text-foreground mt-3">404</h1>
      <p className="text-muted mt-4 max-w-sm text-center text-lg">
        This page isn&apos;t part of the current workflow.
      </p>
      <Link
        to="/home"
        className="bg-accent text-accent-foreground hover:bg-accent-hover mt-8 h-12 rounded-sm px-6 text-sm font-semibold"
      >
        Return home
      </Link>
    </div>
  );
}
